import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Store from '../pages/store';
import Jewelry from '../pages/store/jewelry';
import JewelryStore from '../pages/store/jewelry/StoreFront';
import JewelryCheckout from '../pages/store/jewelry/Checkout';
import Groceries from '../pages/store/groceries';
import GroceriesStore from '../pages/store/groceries/StoreFront';
import GroceriesCheckout from '../pages/store/groceries/Checkout';
import Clothes from '../pages/store/clothes';
import ClothesStore from '../pages/store/clothes/StoreFront';
import ClothesCheckout from '../pages/store/clothes/Checkout';
import { CartProvider } from '../pages/store/CartContext';
import StripeReturn from '../pages/store/common/StripeReturn';
import OrderConfirmation from '../pages/store/groceries/OrderConfirmation';
import AuthWrapper from '../components/AuthWrapper';

const StoreRoutes = () => {
  // Get authentication state from Redux
  const { token, user } = useSelector(state => state.auth || {});
  const isAuthenticated = Boolean(token && user?.id);
  
  return (
    <CartProvider>
      <Routes>
        {/* Main store page already handled in App.jsx */}
        <Route index element={<Navigate to="/store" replace />} />
        <Route path="stripe-return" element={<StripeReturn />} />
        
        {/* Jewelry Routes */}
        <Route path="jewelry" element={
          <AuthWrapper>
            <Jewelry />
          </AuthWrapper>
        } />
        <Route path="jewelry/storefront/:storeId?" element={
          <AuthWrapper>
            <JewelryStore />
          </AuthWrapper>
        } />
        <Route path="jewelry/checkout" element={
          <AuthWrapper>
            <JewelryCheckout />
          </AuthWrapper>
        } />
        
        {/* Groceries Routes */}
        <Route path="groceries" element={
          <AuthWrapper>
            <Groceries />
          </AuthWrapper>
        } />
        <Route path="groceries/storefront/:storeId?" element={
          <AuthWrapper>
            <GroceriesStore />
          </AuthWrapper>
        } />
        <Route path="groceries/checkout" element={
          <AuthWrapper>
            <GroceriesCheckout />
          </AuthWrapper>
        } />
        <Route path="groceries/order-confirmation" element={
          <AuthWrapper>
            <OrderConfirmation />
          </AuthWrapper>
        } />
        
        {/* Clothes Routes */}
        <Route path="clothes" element={
          <AuthWrapper>
            <Clothes />
          </AuthWrapper>
        } />
        <Route path="clothes/storefront/:storeId?" element={
          <AuthWrapper>
            <ClothesStore />
          </AuthWrapper>
        } />
        <Route path="clothes/checkout" element={
          <AuthWrapper>
            <ClothesCheckout />
          </AuthWrapper>
        } />
      </Routes>
    </CartProvider>
  );
};

export default StoreRoutes;